import { render, staticRenderFns } from "./facebookData.vue?vue&type=template&id=627aceb2&"
import script from "./facebookData.vue?vue&type=script&lang=js&"
export * from "./facebookData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('627aceb2')) {
      api.createRecord('627aceb2', component.options)
    } else {
      api.reload('627aceb2', component.options)
    }
    module.hot.accept("./facebookData.vue?vue&type=template&id=627aceb2&", function () {
      api.rerender('627aceb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/management/facebookData.vue"
export default component.exports